module.exports = {"title":"Search Results TODO","hideTransactionInfo":"Hide transaction info"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/locales/en.json
// module id = 1414
// module chunks = 0